import { render, staticRenderFns } from "./ModalTelaDeAgrupamento.vue?vue&type=template&id=15fe7920&scoped=true&"
import script from "./ModalTelaDeAgrupamento.vue?vue&type=script&lang=js&"
export * from "./ModalTelaDeAgrupamento.vue?vue&type=script&lang=js&"
import style0 from "./ModalTelaDeAgrupamento.vue?vue&type=style&index=0&id=15fe7920&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe7920",
  null
  
)

export default component.exports